import { render, staticRenderFns } from "./PromoDropdown.vue?vue&type=template&id=ff8198b8&scoped=true"
import script from "./PromoDropdown.vue?vue&type=script&lang=js"
export * from "./PromoDropdown.vue?vue&type=script&lang=js"
import style0 from "./PromoDropdown.vue?vue&type=style&index=0&id=ff8198b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8198b8",
  null
  
)

export default component.exports